<div class="col-12 login-container">
  <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="title">
      <span class="text">{{ 'LeadPortal.auth.all-stars-sso-title' | translate }}</span>
    </div>
    <div class="subtitle">
      <span class="text">{{ 'LeadPortal.auth.all-stars-sso-subtitle' | translate }}</span>
    </div>
    <div class="d-flex flex-column">
      <cap-input
        formControlName="email"
        [label]="'auth.sign-in.email' | translate"
        [placeholder]="'LeadPortal.auth.sign-in.email' | translate"
        styleClass="w-100"
        data-test="email" />
    </div>

    <div class="m-0 p-0 pb-2">
      <span class="warning-text-sso">{{ 'LeadPortal.auth.all-stars-sso-warning-text' | translate }}</span>
    </div>

    <div class="login-actions d-flex align-items-center gap-3">
      <cap-button
        styleClass="secondary"
        routerLink="/auth/login"
        type="button"
        [label]="'auth.forgot-password.button.back' | translate"
        data-test="back-button">
      </cap-button>

      <cap-button
        styleClass="secondary"
        data-test="login-sso-button"
        (onClick)="loginSSO()"
        [label]="'LeadPortal.button.continue' | translate" />
    </div>
  </form>
</div>
